import { Logger } from '@byted/serial-utils/dist/tools/logger';

export enum LoggerBusiness {
    Account = 'account',
    Magic = 'magic',
}

export const AccountLogger = new Logger(LoggerBusiness.Account);
export const MagicLogger = new Logger(LoggerBusiness.Magic);
